<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      南山书城站<br>
站点介绍<br>
南山书城站位于深圳市南山区海德二道与南海大道交叉口的东侧，车站周边规划以居住、商业、教育为主体。车站为地下车站，地下一层为站厅层，地下二层为站台层，共设有9个出入口，其中F、G、H出入口为相连物业区通道口。车站设有自动扶梯、垂梯、公共洗手间等便民设施。车站以米白色为主色调，立柱用浅绿色装饰做点缀，利用书本图案元素，结合白色拱弧形的造型天花，打造出高雅别致、颇具书香文化的空间氛围。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:18	23:58	9号线	3分50秒	5分55秒<br>
文锦	06:20	23:11	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:19	23:58	9号线	4分25秒	5分55秒<br>
文锦	06:20	23:11	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:19	00:58	9号线	4分钟	5分55秒<br>
文锦	06:20	00:11	9号线	4分钟	5分55秒<br><br>

站点出口信息<br><br>
A出入口:<br>
南海大道东侧（南）、海德二道南侧（东）、金钟大厦、华彩天成、青春家园、天悦园<br><br>
B出入口:<br>
南海大道东侧（北）、海德二道北侧（东）、文心公园<br><br>
C出入口:<br>
海德二道北侧（西）、南海大道西侧（北）、山东大厦、缤纷假日小区<br><br>
D出入口:<br>
海德二道南侧（西）、南山小学、海典居<br><br>
E出入口:<br>
暂未开通<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 南山书城地铁站②<br>
37、70、113、226、M106、M133、M448、M475、M527<br><br>
D出入口:<br>
公交站名： 南山书城地铁站②<br>
19、37、70、113、226、M133、M483、M527、M539<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>